export const state = () => {
  return {
    authentication: null,
    decodedAuthentication: null,
    userRole: null,
    organisations: null,
    selectedOrganisation: null,
    logSources: null,
    grokPatterns: null,
    products: null,
    tokenResetTimestamp: null,
    menuCollapsed: false,
    listCollapsed: false,
  };
};

export default state;
